var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFarmCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 138,
    viewBox: "0 0 106 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.0879C0 3.47694 5.92614 -1.33926 13.2373 0.330868L92.7625 18.4971C100.073 20.1671 106 25.6012 106 30.6475V107.352C106 112.393 100.074 117.832 92.7625 119.503L13.2373 137.669C5.92656 139.339 0 134.532 0 126.912V11.0879ZM22.525 39.2275C22.525 33.0821 27.6875 28.8261 34.0433 29.7195L68.6091 34.5785C74.9707 35.4727 80.1275 40.1587 80.1275 45.0476C80.1275 49.9351 74.965 53.5797 68.6091 53.1887L34.0433 51.063C27.6819 50.6717 22.525 45.3741 22.525 39.2275ZM21.912 68.9998C21.912 62.6389 27.2558 57.6932 33.8345 57.9535L69.6141 59.3679C76.1989 59.6285 81.537 63.9396 81.537 68.9998C81.537 74.059 76.1932 78.3715 69.6141 78.6317L33.8345 80.0462C27.2499 80.3067 21.912 75.3625 21.912 68.9998ZM35.775 110.532C43.0928 109.439 49.025 103.345 49.025 96.9202C49.025 90.4952 43.0928 85.6516 35.775 86.1016C28.4572 86.5517 22.525 92.646 22.525 99.7139C22.525 106.782 28.4572 111.625 35.775 110.532Z",
    fill: "#7A0BD3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmCart);
export default __webpack_public_path__ + "static/media/farm-cart.bcb65ce5b6f4053e300da81cc0b2e6ed.svg";
export { ForwardRef as ReactComponent };